import type { Environment } from './config'

export interface DomAttributes {
  email: string | null
  code: string | null
  deliveryId: string | null
  env: Environment | null
  executedBy: string | null
}

/**
 * Read authentication and config from DOM wrapper element
 * SFCC embeds the component with these data attributes
 * @returns Parsed attributes from the EmailPreferenceCenter wrapper
 */
export function readDomAttributes(): DomAttributes {
  const wrapper = document.getElementById('EmailPreferenceCenter')

  if (!wrapper) {
    console.warn('[DOM] EmailPreferenceCenter wrapper not found')
    return {
      email: null,
      code: null,
      deliveryId: null,
      env: null,
      executedBy: null,
    }
  }

  const email = wrapper.getAttribute('data-customerEmail') || null
  const code = wrapper.getAttribute('data-authCode') || null
  const deliveryId = wrapper.getAttribute('data-deliveryId') || null
  const envAttr = wrapper.getAttribute('data-env') || null
  const executedBy = wrapper.getAttribute('data-executedBy') || null

  // Validate environment
  const env =
    envAttr && ['tst', 'acc', 'prd'].includes(envAttr)
      ? (envAttr as Environment)
      : null

  return {
    email,
    code,
    deliveryId,
    env,
    executedBy,
  }
}
